<template>
  <div class="md:-mb-4">
    <ProductBadge
      v-if="product.isSoldOut"
      class="left-0 top-0 ml-0"
      :badge-label="badgeLabel"
    />
    <h1 class="font-semibold my-2 md:my-0">
      <div class="flex">
        <span v-if="productBrand" class="block text-sm uppercase">
          {{ productBrand }}
        </span>
      </div>
      <span
        ref="productNameRef"
        class="leading-2 text-2lg sm:text-xl"
        data-qa="product-description"
      >
        {{ productName }}
      </span>

      <span
        v-if="productOrderNumber"
        class="hidden text-sm text-gray-secondary sm:block"
      >
        {{ $t('pdp.main_order_number') }}
        <span data-test-id="product-order-number">{{
          productOrderNumber
        }}</span>
      </span>
    </h1>
  </div>
</template>

<script setup lang="ts">
// TODO: Use alternative approach for badge label
import type { Product } from '@scayle/storefront-nuxt'
import { useI18n } from 'vue-i18n'
import { getBadgeLabel } from '~/utils/product'

const i18n = useI18n()

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  productName: {
    type: String,
    required: true,
  },
  productBrand: {
    type: String,
    required: true,
  },
  productOrderNumber: {
    type: String as PropType<string>,
    default: '',
  },
})

const badgeLabel = computed(() => {
  const label = getBadgeLabel({ isSoldOut: props.product.isSoldOut })
  return i18n.t(`badge_labels.${label}`)
})
</script>
